import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=c36201cc&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"
import style0 from "./reports.vue?vue&type=style&index=0&id=c36201cc&prod&scoped=true&lang=css"
import style1 from "./reports.vue?vue&type=style&index=1&id=c36201cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36201cc",
  null
  
)

export default component.exports